import Guid from "_shared/guids/guid";
import ForumInfo from "notifications/entities/forum-info/forum-info";
import MessageInfoSchema, {
  MessageInfoJSON,
  MessageInfoParams,
} from "notifications/entities/message-info/message-info-schema";
import MessageContent from "notifications/values/message-content/message-content";
import MessageSubject from "notifications/values/message-subject/message-subject";
import RecipientName from "notifications/values/recipient-name/recipient-name";
import SenderName from "notifications/values/sender-name/sender-name";

export default class MessageInfo {
  public static create(values: MessageInfoParams): MessageInfo {
    const parsed = MessageInfoSchema.validate(values);
    return new MessageInfo(parsed);
  }

  public static fromJSON(value: MessageInfoJSON): MessageInfo {
    const params = MessageInfoSchema.deserialize(value);
    return new MessageInfo(params);
  }

  public readonly id: Guid;
  public readonly senderId?: Guid | null;
  public readonly senderName?: SenderName;
  public readonly recipientId?: Guid | null;
  public readonly recipientName: RecipientName;
  public readonly forumInfo: ForumInfo;
  public readonly content?: MessageContent;
  public readonly subject?: MessageSubject;

  public toJSON(): MessageInfoJSON {
    return MessageInfoSchema.serialize({
      ...this,
      forumInfo: this.forumInfo.toForum(),
    });
  }

  public isEqualTo(other: MessageInfo): boolean {
    return (
      this.id.isEqualTo(other.id) &&
      ((this.senderId === undefined && other.senderId === undefined) ||
        (this.senderId === null && other.senderId === null) ||
        (this.senderId != undefined && other.senderId != undefined && this.senderId.isEqualTo(other.senderId))) &&
      ((this.senderName === undefined && other.senderName === undefined) ||
        (this.senderName != undefined &&
          other.senderName != undefined &&
          this.senderName.isEqualTo(other.senderName))) &&
      ((this.recipientId === undefined && other.recipientId === undefined) ||
        (this.recipientId === null && other.recipientId === null) ||
        (this.recipientId != undefined &&
          other.recipientId != undefined &&
          this.recipientId.isEqualTo(other.recipientId))) &&
      this.recipientName.isEqualTo(other.recipientName) &&
      this.forumInfo.isEqualTo(other.forumInfo) &&
      ((this.content === undefined && other.content === undefined) ||
        (this.content != undefined && other.content != undefined && this.content.isEqualTo(other.content))) &&
      ((this.subject === undefined && other.subject === undefined) ||
        (this.subject != undefined && other.subject != undefined && this.subject.isEqualTo(other.subject)))
    );
  }

  public toString(): string {
    return `MessageInfo { id: ${this.id.value}, senderId: ${this.senderId?.value ?? "undefined"}, senderName: ${
      this.senderName?.toString() ?? "undefined"
    }, recipientId: ${
      this.recipientId?.value ?? "undefined"
    }, recipientName: ${this.recipientName.toString()}, forum: ${this.forumInfo.toString()}, content: ${
      this.content?.toString() ?? "undefined"
    }, subject: ${this.subject?.toString() ?? "undefined"} }`;
  }

  private constructor(values: MessageInfoParams) {
    this.id = values.id;
    this.senderId = values.senderId;
    this.senderName = values.senderName;
    this.recipientId = values.recipientId;
    this.recipientName = values.recipientName;
    this.forumInfo = values.forumInfo;
    this.content = values.content;
    this.subject = values.subject;
  }
}
